import {
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ElectricalLinePoi } from './PoiDialog.types';

const useStyles = makeStyles()(() => ({
  cell: {
    border: 0,
    padding: `0 16px 4px 0`,
  },
}));

export const ElectricLineDialogContent = (
  props: ElectricalLinePoi,
): JSX.Element => {
  const { list, title } = props;
  const { classes } = useStyles();

  return (
    <>
      <DialogTitle id="alert-dialog-title" sx={{ paddingBottom: '4px' }}>
        <Typography
          component="span"
          variant="body1"
          sx={{
            fontWeight: 'bold',
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Table>
          <TableBody>
            {list.map(({ name, value }) => (
              <TableRow key={name}>
                <TableCell component="th" scope="row" className={classes.cell}>
                  <Typography
                    variant="body2"
                    color="secondary"
                    sx={{
                      textTransform: 'uppercase',
                    }}
                  >
                    {name}
                  </Typography>
                </TableCell>
                <TableCell className={classes.cell}>
                  <Typography
                    variant="body2"
                    sx={{
                      textTransform: 'capitalize',
                    }}
                  >
                    {value}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </>
  );
};
